import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=3547444e&scoped=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AddRoleModal.vue?vue&type=style&index=0&id=3547444e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547444e",
  null
  
)

export default component.exports